export default "__VITE_ASSET__DxQ7SCHP__"